import { Link } from 'react-router-dom';
import config from "../utils/config";

const LINKS = [
  { label: 'Blog', to: '/blog' },
  { label: 'Contact Us', href: 'mailto:schedulyevents@gmail.com' },
  { label: 'Terms & Conditions', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 py-10 px-6">
      <div className="flex flex-col items-center gap-5">
        <div className="flex items-center gap-2 font-black text-base text-slate-200">
          <span className="w-7 h-7 bg-indigo-600 rounded-lg flex items-center justify-center text-white text-sm leading-none">
            📅
          </span>
          Scheduly
        </div>

        <nav className="flex flex-wrap gap-6 justify-center">
          {LINKS.map(({ label, to, href }) =>
            to ? (
              <Link
                key={label}
                to={to}
                className="text-slate-500 text-sm hover:text-slate-400 no-underline transition-colors"
              >
                {label}
              </Link>
            ) : (
              <a
                key={label}
                href={href}
                className="text-slate-500 text-sm hover:text-slate-400 no-underline transition-colors"
              >
                {label}
              </a>
            )
          )}
        </nav>

        <p className="text-slate-600 text-xs">
          © {new Date().getFullYear()} Scheduly · Est. 2022 · All rights reserved.
        </p>
        {config.version && (
          <p className="text-slate-700 text-xs">
            v{config.version}
          </p>
        )}
      </div>
    </footer>
  );
}
